const ACTION_KEY = 'EXTENSION_REPORT_PDF';

const initialState = () => ({
  loading: false,
  extensionReportData: null
});

const reducer = (state = initialState(), action) => {
  switch (action.type) {
    case `${ACTION_KEY}_PENDING`: {
      return {
        ...state,
        loading: true
      };
    }
    case `${ACTION_KEY}_REJECTED`: {
      return {
        ...state,
        loading: false
      };
    }
    case `${ACTION_KEY}_FULFILLED`: {
      const extensionReportData = action.payload;
      return {
        ...state,
        loading: false,
        extensionReportData
      };
    }

    case `${ACTION_KEY}_RESET`: {
      return initialState();
    }

    default:
      return state;
  }
};

export default reducer;
